export enum ReleaseMilestone {
    Kickoff = 'kickoff',
    BuildAvailable = 'buildAvailable',
    Submission = 'submission',
    SubmissionApproved = 'submissionApproved',
    ReleaseCompleted = 'releaseCompleted',
}

export const releaseMilestoneLabels: Record<ReleaseMilestone, string> = {
    [ReleaseMilestone.Kickoff]: 'Kickoff',
    [ReleaseMilestone.BuildAvailable]: 'Build available for testing',
    [ReleaseMilestone.Submission]: 'Submission',
    [ReleaseMilestone.SubmissionApproved]: 'Submission approved',
    [ReleaseMilestone.ReleaseCompleted]: 'Release completed',
};

export const allReleaseMilestones: ReleaseMilestone[] = [
    ReleaseMilestone.Kickoff,
    ReleaseMilestone.BuildAvailable,
    ReleaseMilestone.Submission,
    ReleaseMilestone.SubmissionApproved,
    ReleaseMilestone.ReleaseCompleted,
];
